import React, { HTMLInputTypeAttribute } from "react";
import './DropDownButton.css';

interface IDropDownButtonProps{
    isOpen: boolean;
    isActive: boolean;
    onChangeOpen: (nextValue: boolean, isActive: boolean)=>void;
    className?: string;
}

export const DropDownButton = ({isOpen, isActive, onChangeOpen, className}: IDropDownButtonProps)=>{
    return <div className={`button commonDropDownButton ${isOpen ? 'commonDropDownButton--open' : ''} ${!isActive ? 'commonDropDownButton--inactive' : ''} ${className || ''}`} 
        onClick={()=>onChangeOpen(!isOpen, isActive)}
    >      
    </div>
}

export const DropDownButtonColored = ({isOpen, isActive, onChangeOpen, className}: IDropDownButtonProps)=>{
    return <div className={`button commonDropDownButton commonDropDownButtonColored ${isOpen ? 'commonDropDownButton--open' : ''} ${!isActive ? 'commonDropDownButton--inactive' : ''} ${className || ''}`} 
        onClick={()=>onChangeOpen(!isOpen, isActive)}
    >
        <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 5L0 0H10L5 5Z"/>
        </svg>    
    </div>
}